// Volume units data for conversion routes
export const volumeUnits = [
  { id: 'cubicmeter', name: 'Cubic Meter', symbol: 'm³', plural: 'Cubic Meters', factor: 1 },
  { id: 'cubickilometer', name: 'Cubic Kilometer', symbol: 'km³', plural: 'Cubic Kilometers', factor: 1000000000 },
  { id: 'cubiccentimeter', name: 'Cubic Centimeter', symbol: 'cm³', plural: 'Cubic Centimeters', factor: 0.000001 },
  { id: 'cubicmillimeter', name: 'Cubic Millimeter', symbol: 'mm³', plural: 'Cubic Millimeters', factor: 0.000000001 },
  { id: 'liter', name: 'Liter', symbol: 'L', plural: 'Liters', factor: 0.001 },
  { id: 'milliliter', name: 'Milliliter', symbol: 'mL', plural: 'Milliliters', factor: 0.000001 },
  { id: 'gallon-us', name: 'US Gallon', symbol: 'gal', plural: 'US Gallons', factor: 0.003785411784 },
  { id: 'gallon-uk', name: 'UK Gallon', symbol: 'gal (UK)', plural: 'UK Gallons', factor: 0.00454609 },
  { id: 'quart-us', name: 'US Quart', symbol: 'qt', plural: 'US Quarts', factor: 0.000946352946 },
  { id: 'pint-us', name: 'US Pint', symbol: 'pt', plural: 'US Pints', factor: 0.000473176473 },
  { id: 'cup-us', name: 'US Cup', symbol: 'cup', plural: 'US Cups', factor: 0.0002365882365 },
  { id: 'fluid-ounce', name: 'US Fluid Ounce', symbol: 'fl oz', plural: 'US Fluid Ounces', factor: 0.0000295735295625 },
  { id: 'tablespoon', name: 'Tablespoon', symbol: 'tbsp', plural: 'Tablespoons', factor: 0.0000147867647813 },
  { id: 'teaspoon', name: 'Teaspoon', symbol: 'tsp', plural: 'Teaspoons', factor: 0.00000492892159375 },
];

// Popular conversions matching common usage
export const popularVolumeConversions = [
  { from: 'liter', to: 'gallon-us' },
  { from: 'gallon-us', to: 'liter' },
  { from: 'milliliter', to: 'cup-us' },
  { from: 'cup-us', to: 'milliliter' },
  { from: 'liter', to: 'milliliter' },
  { from: 'milliliter', to: 'liter' },
  { from: 'gallon-us', to: 'quart-us' },
  { from: 'quart-us', to: 'gallon-us' },
  { from: 'cup-us', to: 'tablespoon' },
  { from: 'tablespoon', to: 'cup-us' },
  { from: 'tablespoon', to: 'teaspoon' },
  { from: 'teaspoon', to: 'tablespoon' },
  { from: 'fluid-ounce', to: 'milliliter' },
  { from: 'milliliter', to: 'fluid-ounce' },
  { from: 'gallon-us', to: 'gallon-uk' },
  { from: 'gallon-uk', to: 'gallon-us' },
  { from: 'cubicmeter', to: 'liter' },
  { from: 'liter', to: 'cubicmeter' },
  { from: 'cubiccentimeter', to: 'milliliter' },
  { from: 'milliliter', to: 'cubiccentimeter' },
  { from: 'pint-us', to: 'cup-us' },
  { from: 'cup-us', to: 'pint-us' },
  { from: 'quart-us', to: 'pint-us' },
  { from: 'pint-us', to: 'quart-us' },
];

// Get unit by ID
export const getUnitById = (id) => {
  return volumeUnits.find(unit => unit.id === id);
};

// Convert between units
export const convertVolume = (value, fromId, toId) => {
  const fromUnit = getUnitById(fromId);
  const toUnit = getUnitById(toId);
  if (!fromUnit || !toUnit) return null;

  // Convert to cubic meters first, then to target unit
  const cubicMeters = value * fromUnit.factor;
  return cubicMeters / toUnit.factor;
};

// Format conversion slug to readable text
export const formatConversionTitle = (fromUnit, toUnit) => {
  return `Convert ${fromUnit.plural} to ${toUnit.plural}`;
};

// Generate SEO description
export const generateSEODescription = (fromUnit, toUnit) => {
  const sampleValue = 1;
  const result = convertVolume(sampleValue, fromUnit.id, toUnit.id);
  const formattedResult = result < 0.001 || result > 1000000
    ? result.toExponential(4)
    : result.toPrecision(6).replace(/\.?0+$/, '');

  return `Convert ${fromUnit.plural} to ${toUnit.plural}. 1 ${fromUnit.name} = ${formattedResult} ${toUnit.plural}. Free online volume unit converter.`;
};
